import CalculationActions from '../../components/calculation-form/calculation-actions'
import CalculationPositionActions from '../../components/calculation-form/calculation-position-actions'
import isCalculation from '../../helpers/is-calculation'
import type { CalculationColumn } from '../../types/column-types'

export const actionsColumn: CalculationColumn = {
    dataIndex: '8',
    title: 'Действия',
    fixed: 'right',
    width: 120,
    render(v, record, index) {
        if (isCalculation(record)) {
            return <CalculationActions calculation={record} />
        }
        return <CalculationPositionActions position={record} />
    },
}
